var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-wrap"},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"title"},[_c('span',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),(_vm.description)?_c('span',[_vm._v(_vm._s(_vm.description))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"right"},[_vm._t("right")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64e8b824","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail-page/title.vue
// module id = null
// module chunks = 